module.exports = __webpack_public_path__ + "98763359d3e666d5886f8085c3d9b40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_edit_icon.png
// module id = 89
// module chunks = 0 1 2 3 4